export const getTeamCentralGraphqlUrl: any = (baseUrl: string, cloudId: string) =>
	`${baseUrl}/townsquare/s/${cloudId}/graphql`;
